import loadingComponent from '../components/loading.vue';
import Vue from 'vue';
let $vm;
if(!$vm){
    const loadingPlugin=Vue.extend(loadingComponent);
    $vm=new loadingPlugin({
        el:document.createElement('div')
    })
    document.body.append($vm.$el)
}
$vm.show=false;
let loading={
    show(){
        $vm.show=true;
    },
    hide(){
        $vm.show=false;
    }
}
export default{
    install(){   
        if (!Vue.$loading) {
            Vue.$loading = loading;
        }
        Vue.mixin({
            created() {
                this.$loading = Vue.$loading;
            }
        })

    }
}